import { escapeRegExp } from 'lodash';

export const escapeForDoubleQuotedString = (value: string): string =>
  value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');

export const escapeForSingleQuotedString = (value: string): string =>
  value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");

export function replaceFlowNameInGotoFlow(
  code: string,
  oldFlowName: string,
  newFlowName: string,
): string {
  if (oldFlowName === newFlowName) {
    return code;
  }
  const escapedOld = escapeRegExp(oldFlowName);
  const safeNewForDouble = escapeForDoubleQuotedString(newFlowName);
  const safeNewForSingle = escapeForSingleQuotedString(newFlowName);

  return code
    .replace(
      new RegExp(`\\bconv\\.goto_flow\\s*\\(\\s*\"${escapedOld}\"`, 'gu'),
      () => `conv.goto_flow("${safeNewForDouble}"`,
    )
    .replace(
      new RegExp(`\\bconv\\.goto_flow\\s*\\(\\s*'${escapedOld}'`, 'gu'),
      () => `conv.goto_flow('${safeNewForSingle}'`,
    );
}

export function replaceVariableNameInCode(
  code: string,
  oldName: string,
  newName: string,
): string {
  const pattern = new RegExp(
    `(^|[^\\w.])conv\\.state\\.${escapeRegExp(oldName)}(?!\\s*\\()\\b`,
    'g',
  );
  return code.replace(
    pattern,
    (_match, prefix: string) => `${prefix}conv.state.${newName}`,
  );
}

export function extractVariableNamesFromCode(code: string): string[] {
  const convStatePattern =
    /(?<![\w\.])conv\.state\.([a-zA-Z_][a-zA-Z0-9_]*)\b(?!\s*\()/g;

  const variableNames: string[] = [];
  let match;
  while ((match = convStatePattern.exec(code)) !== null) {
    const variableName = match[1];
    if (!variableNames.includes(variableName)) {
      variableNames.push(variableName);
    }
  }
  return variableNames;
}
